export const EXPLORER_FOLDER_OPENED_KEY = 'EXPLORER_FOLDER_OPENED_KEY'

export const explorerTitle = 'Проводник'
